import * as yup from 'yup';

export const validationSchema = yup
    .object()
    .shape({
        customer_name: yup.string().required('Please enter Name'),
        customer_mobile: yup.string().required('Please enter Mobile number'),
        scheduleDate: yup.string().required('Please enter Booking Date'),
        project: yup.string().required('Please select Project'),
        lead_source: yup.string().required('Please select Source'),
    }) 